import React from 'react';
import Paper from '@mui/material/Paper';
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {get} from "./api";
import {
  Link, useHistory
} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import Loading from "../molcules/Loading/Loading";
import MyTable from "../atoms/MyTable";

const tableSettings = {
  columns: [
    { title: 'Name', align:'left', field: 'name'},
    { title: 'Owner', align:'right', field: 'owner'},
    { title: 'Address', align:'right', field: 'address'}
  ],
  actions : [{
    content:(<Button variant={'contained'} size={'small'}>Edit</Button>),
    id: 'Edit'
  }]
};

export default function SitesList() {
  const history = useHistory();
  const {isLoading = true, data, error} = useQuery({
    queryKey: ['sites'],
    queryFn: get
  });

  const rowClick = (event, row) => {
    const normalName = row.name.replace(/\s/g, '-').toLowerCase();
    if (row.type === 'hotel') {
      const hotelDefault = normalName === 'rose-castle' ? 'events/list' : 'guests';
      history.push(`/${normalName}/${hotelDefault}`);
    } else {
      history.push(`/${normalName}`);
    }
  };

  if (error) return <p>An error has occurred: {error.message}</p>;

  return (
    <div>
      <div className="heading"><span className="heading-text">Sites</span>
        <Link to="/sites/create" className="head-action">
          <Button variant="outlined" color="primary" startIcon={<AddCircleOutlineIcon/>}>New</Button>
        </Link>
      </div>

      {isLoading && <Loading/>}

      {data && data.data.length &&
        <Paper className={'paper'}>
          <MyTable
            title={''}
            columns={tableSettings.columns}
            data={data.data}
            initialOrder={{orderBy:'name', order:'asc'}}
            actions={tableSettings.actions}
            onRowClick={rowClick}
            onActionClick={(e, actionId, row) => {
              e.stopPropagation();
              history.push( `sites/${row._id}`);
            }}
          />
        </Paper>
      }

      {data && data.data && data.data.length === 0 &&
        <p>No sites found, <Link to="/sites/create">create sites</Link>.</p>}

    </div>
  );
}
